<template>
  <v-dialog
      v-model="show"
      max-width="600px"
    >
      <v-form ref="form" lazy-validation :disabled="loading" @submit="shareProject" onsubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('share.shareProject') }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="show = false"
            >
            <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="invitation.emails"
                  clearable
                  outlined
                  prepend-inner-icon="mdi-at"
                  color="grey"
                  :label="$t('share.emails')"
                  :hint="$t('share.separateEmailsWithComma')"
                  :persistent-hint="true"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="invitation.role"
                  :items="rolesWithText"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              class="raison-btn"
              :disabled="loading || !invitation.emails"
              :loading="loading"
            >
              <v-icon left>mdi-share-variant</v-icon>
              {{ $t('share.share') }}
            </v-btn>
          </v-card-actions>

          <v-list subheader class="pa-6 members">
            <v-list-item
              v-for="(user, index) in users"
              :key="index"
            >

              <v-list-item-action class="mr-4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click.stop="removeUser(user)"
                      icon
                      class="raison-btn elevation-2"
                      v-on="on"
                    >
                      <v-icon>mdi-account-remove-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('share.remove') }}</span>
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title v-text="user.name"></v-list-item-title>
                <v-list-item-subtitle v-text="user.email"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action  v-if="user.status === 'PENDING'">
                <v-chip color="warning" small>{{ $t('share.status.' + user.status) }}</v-chip>
              </v-list-item-action>
              <v-list-item-action>
                <v-chip color="cyan white--text" small @click="invitation.emails = user.email">{{ $t('share.role.' + user.role) }}</v-chip>
              </v-list-item-action>

            </v-list-item>
          </v-list>

        </v-card>
      </v-form>
    </v-dialog>
</template>
<script>
import projectService from '@/services/projects.js'

import userRightMixin from '@/mixins/user-rights-mixin.js'

export default {
  name: 'ShareProjectDialog',

  mixins: [ userRightMixin ],

  data () {
    return {
      invitation: {
        emails: "",
        role: "RUNNER"
      },
      loading: false,
      roles: [
        'RUNNER',
        'EDITOR',
        'OWNER'
      ],
      users: [
      ],
    }
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },

  watch: {
    open(value) {
      if(!value) {
        return
      }
      this.loading = true
      projectService.getSharings(this.project.id)
        .then(response => {
          this.users = response.data
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    }
  },

  computed: {
    rolesWithText() {
      return this.roles.map(role => { return { value: role, text: this.$t('share.role.' + role) }})
    },

    show: {
      get () {
          return this.open;
      },
      set (value) {
        if(!value) {
          this.onCancel()
        }
        this.$emit('update:open', value);
      }
    }
  },

  methods: {
    onCancel() {
      this.users = []
    },
    shareProject(event) {
      event.preventDefault()
      console.log('share project', { ...this.invitation, projectId: this.project.id })
      this.loading = true
      const emails = this.invitation.emails.split(',').map(email => email.trim())
      projectService.share(this.project.id, emails, this.invitation.role)
        .then(response => {
          response.data.forEach(user => {
            const idx = this.users.findIndex(u => u.email === user.email);
            if(idx != -1) {
              console.log('replace user', user, idx)
              this.users.splice(idx, 1, user)
            }
            else {
              console.log('add user', user)
              this.users.splice(0, 0, user)
            }
            this.invitation.emails = ""
          })
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
    removeUser(user) {
      console.log('remove user', user)
      this.loading = true
      var removeSharing;
      if(user.username) {
        removeSharing = projectService.removeSharingByUsername(this.project.id, user.username)
      }
      else {
        removeSharing = projectService.removeSharingByEmail(this.project.id, user.email)
      }
      removeSharing
        .then(() => {
          this.users.splice(this.users.indexOf(user), 1)
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
  },
}
</script>
<style scoped>
.members {
  max-height: 200px;
  overflow-y: auto;
}
</style>
